import { Box, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Card = styled(Link)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  textDecoration: "none",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.secondary.main}`,
  transition: theme.transitions.create("border-color", {
    duration: theme.transitions.duration.shorter,
  }),
  "&:hover": {
    borderColor: theme.palette.secondary.dark,
  },
}));

export const TitleLine = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

export const IconBox = styled(Box)(() => ({
  position: "absolute",
  top: "10px",
  right: "10px",
}));
export const MainText = styled(Typography)`
  word-break: break-all;

  svg {
    vertical-align: top;
  }
`;
